import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Spinner from 'sushiweb/Spinner/Spinner';
import red from 'sushiweb/tokens/color/red';
import Plus from 'sushiweb/Icons/all/Plus';
import Layout from 'sushiweb/Layout';
import HorizontalTabs from 'sushiweb/HorizontalTabs';
import H5 from 'sushiweb/Typography/Heading/H5';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';

import {
  BreadCrumbWrapper,
  DashboardWrapper,
  LayoutContainers,
  SpinnerHolder,
  StyledButton,
  TabContainer,
  TabHeadWrapper,
  TabWrapper,
  tabStyle,
  // StyledButton,
} from '../common/styles';
// import Error from '../common/components/DataTables/components/Error';
import DetailsWrapper from '../common/components/DetailsWrapper/DetailsWrapper';
import EmployeeTable from './EmployeeTable';
import GroupsTable from './GroupsTable';
import CreateGroupModal from '../common/components/CreateGroupModal';
import ErrorPage from '../common/components/ErrorPage';
import {
  EMPLOYEES,
  REFRESH_LABEL,
  applicableFlowTypes,
  currentFlowTypeEnum,
  exitedEmployeesInfo,
  onboardedEmployeesInfo,
  onboardingPendingEmployeesInfo,
} from '../common/components/constants';
import { DASHBOARD_ROUTE, HOME_ROUTE } from '../../constants/routes';
import EmptyStateV2 from '../common/components/EmptyStateV2/EmptyStateV2';
import { emptyEmployeesStateTitle } from '../../constants';
import Banner from '../common/components/Banner';
import ZTrackingClient from '../../jumbo/ZTrackingClient';
import { isEmployeeAdditionButtonDisabled } from '../../utility';

const Employees = ({
  currentFlow,
  viewOnlyMode,
  selectedWorkspace,
  getAllGroups,
  fetchingEmployeeSection,
  getEmployeeSection,
  employeesSecton,
  fetchedEmployeeSection,
  getAllCompanyMappedOffices,
}) => {
  localStorage.activeIndexEmployees =
    localStorage.activeIndexEmployees !== undefined
      ? Number(localStorage.activeIndexEmployees)
      : 1;
  const [emptyEmployees, setEmptyEmployees] = useState(true);
  const [activeEmployees, setActiveEmployees] = useState(0);
  const [employeesExited, setEmployeesExited] = useState(0);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [onboardingPending, setOnboardingPending] = useState(0);
  const [createGroupModalVisible, setCreateGroupModalVisible] = useState(false);
  const [activeIndexEmployees, setActiveIndexEmployees] = useState(
    localStorage.activeIndexEmployees !== undefined
      ? Number(localStorage.activeIndexEmployees)
      : 0,
  );

  const renderEmployeeAdditionButton = () => {
    const isDisabled = isEmployeeAdditionButtonDisabled(
      selectedWorkspace,
      viewOnlyMode,
    );
    const button = (
      <StyledButton
        onClick={handleActiveStateButtonClick}
        disabled={isDisabled}
        iconAlign='left'
        icon={<Plus />}
      >
        {activeStateMapping[activeIndexEmployees]?.buttonText}
      </StyledButton>
    );

    return isDisabled ? (
      <Tooltip
        position='top'
        label='This feature is disabled, please contact your relationship manager'
        appearance='light'
        size='big'
        style={{
          fontSize: '12px',
          opacity: 0.8,
          marginRight: '10px',
          marginLeft: '20px',
          padding: '10px',
        }}
      >
        {button}
      </Tooltip>
    ) : (
      button
    );
  };

  const handleTabsClick = val => () => {
    setActiveIndexEmployees(val);
    localStorage.activeIndexEmployees = Number(val);
    const comp = val === 0 ? 'EMPLOYEES_TAB' : 'TEAMS_TAB';
    ZTrackingClient.recordClick({
      ui_source: 'EMPLOYEES',
      component: comp,
    });
  };

  const closeCreateGroupModal = () => {
    setCreateGroupModalVisible(false);
    getEmployeeSection({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
    getAllGroups({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
  };

  const openCreateGroupModal = () => {
    setCreateGroupModalVisible(true);

    ZTrackingClient.recordClick({
      ui_source: 'EMPLOYEES',
      component: 'CREATE_NEW_TEAM_BUTTON',
    });
  };
  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id) {
      getEmployeeSection({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
      getAllCompanyMappedOffices();
    }
  }, [selectedWorkspace, currentFlow]);

  useEffect(() => {
    if (!fetchingEmployeeSection && fetchedEmployeeSection) {
      const actEmp = employeesSecton?.employees_detail?.active_employees ?? 0;
      const exitEmp = employeesSecton?.employees_detail?.employees_exited ?? 0;
      const onboardPendingEmp =
        employeesSecton?.employees_detail?.employees_added ?? 0;
      setActiveEmployees(actEmp);
      setEmployeesExited(exitEmp);
      setOnboardingPending(onboardPendingEmp);
      setEmptyEmployees(
        employeesSecton?.employees_detail?.is_section_empty ?? 0,
      );
      setTotalEmployees(actEmp + exitEmp + onboardPendingEmp);
      // setTotalEmployees(employeesSecton?.employees_detail?.total_employees ?? 0);
    }
  }, [fetchingEmployeeSection]);

  useEffect(() => {
    ZTrackingClient.recordImpression({
      ui_source: 'EMPLOYEES',
      component: 'SIDE_NAV_BAR',
    });
  }, []);

  const showSelectedTable = () => {
    if (activeIndexEmployees === 1) return <GroupsTable />;
    return <EmployeeTable />;
  };
  const handleActiveStateButtonClick = () => {
    if (activeIndexEmployees === 0) {
      openCreateGroupModal();
    }
    if (activeIndexEmployees === 1) {
      openCreateGroupModal();
    }
  };
  // Need to change this when Add employee CTA is made
  const activeStateMapping = {
    0: {
      buttonText: 'Create new team',
    },
    1: {
      buttonText: 'Create new team',
    },
  };

  const refreshPage = () => {
    getEmployeeSection(selectedWorkspace.workspace_id);
  };

  const ActionComponent = () => {
    return (
      <div>
        {/* <Button icon={<Plus />} iconAlign='left' onClick={uploadEmployees}>
          Bulk Add
        </Button> */}
        <StyledButton
          icon={<Plus />}
          iconAlign='left'
          onClick={openCreateGroupModal}
          disabled={viewOnlyMode}
        >
          Add employees
        </StyledButton>
      </div>
    );
  };

  if (fetchingEmployeeSection) {
    return (
      <DashboardWrapper>
        <SpinnerHolder className='center'>
          <Spinner color={red.z_red} size='medium' />
        </SpinnerHolder>
      </DashboardWrapper>
    );
  }

  if (!fetchedEmployeeSection) {
    return (
      <DashboardWrapper>
        <ErrorPage
          showAction
          actionLabel={REFRESH_LABEL}
          clickAction={refreshPage}
        />
      </DashboardWrapper>
    );
  }

  return emptyEmployees ? (
    <DashboardWrapper>
      {createGroupModalVisible && (
        <CreateGroupModal
          closeModal={closeCreateGroupModal}
          isVisible={createGroupModalVisible}
          heading='Create new team'
        />
      )}
      <EmptyStateV2
        state={EMPLOYEES}
        title={emptyEmployeesStateTitle}
        actionComponent={ActionComponent}
      />
    </DashboardWrapper>
  ) : (
    <DashboardWrapper>
      {createGroupModalVisible && (
        <CreateGroupModal
          closeModal={closeCreateGroupModal}
          isVisible={createGroupModalVisible}
          heading='Create new team'
        />
      )}
      {viewOnlyMode && <Banner />}
      <BreadCrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-400, #AFB4C0)' }}
            linkTo={`${DASHBOARD_ROUTE}#${HOME_ROUTE}`}
          >
            Home
          </Breadcrumb.Link>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-800, #414A5D)' }}
          >
            Employees
          </Breadcrumb.Link>
        </Breadcrumb>
      </BreadCrumbWrapper>
      <TabHeadWrapper>
        <H5>Summary</H5>
        <div>{renderEmployeeAdditionButton()}</div>
      </TabHeadWrapper>
      <LayoutContainers>
        <Layout gap={20}>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip
              tooltipMessage={onboardedEmployeesInfo}
              tooltipDirection='bottomRight'
              label='Onboarded'
              value={`${activeEmployees} / ${totalEmployees}`}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip
              tooltipMessage={onboardingPendingEmployeesInfo}
              tooltipDirection='bottomRight'
              label='Onboarding pending'
              value={`${onboardingPending} / ${totalEmployees}`}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip
              tooltipMessage={exitedEmployeesInfo}
              tooltipDirection='bottomRight'
              label='Exited'
              value={`${employeesExited} / ${totalEmployees}`}
            />
          </Layout.Item>
        </Layout>
      </LayoutContainers>
      <TabWrapper>
        <TabContainer>
          <HorizontalTabs
            style={{
              width: 'auto',
              marginBottom: '-4.5px',
              marginLeft: '-3px',
            }}
            alignLinks='left'
            additionalGap='1.8rem'
          >
            <HorizontalTabs.Link
              active={activeIndexEmployees === 0}
              onClick={handleTabsClick(0)}
              style={{
                width: '140px',
                color:
                  activeIndexEmployees === 0
                    ? 'var(--coolgreycoolgrey-800, #414A5D)'
                    : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                ...tabStyle,
              }}
            >
              Employees
            </HorizontalTabs.Link>
            <HorizontalTabs.Link
              active={activeIndexEmployees === 1}
              onClick={handleTabsClick(1)}
              style={{
                width: '110px',
                color:
                  activeIndexEmployees === 1
                    ? 'var(--coolgreycoolgrey-800, #414A5D)'
                    : 'var(--coolgreycoolgrey-400, #AFB4C0)',
                ...tabStyle,
              }}
            >
              Teams
            </HorizontalTabs.Link>
          </HorizontalTabs>
        </TabContainer>
        {showSelectedTable()}
      </TabWrapper>
    </DashboardWrapper>
  );
};

Employees.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  employeesSecton: PropTypes.objectOf(PropTypes.any),
  getEmployeeSection: PropTypes.func,
  getAllGroups: PropTypes.func,
  fetchingEmployeeSection: PropTypes.bool,
  fetchedEmployeeSection: PropTypes.bool,
  viewOnlyMode: PropTypes.bool,
  getAllCompanyMappedOffices: PropTypes.func,
};

Employees.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  selectedWorkspace: {},
  employeesSecton: {},
  getEmployeeSection: _noop,
  getAllGroups: _noop,
  fetchingEmployeeSection: true,
  fetchedEmployeeSection: true,
  viewOnlyMode: false,
  getAllCompanyMappedOffices: _noop,
};

export default Employees;
